var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 200,
    viewBox: "0 0 199 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7205 168.894C10.3365 187.479 22.7545 191.348 31.4853 187.479C48.3704 179.998 92.232 171.639 137.279 191.287C196.942 217.311 209.637 178.048 190.595 138.334C171.554 98.6192 165.1 58.457 187.051 36.3299C209.002 14.2027 180.277 -20.4121 129.264 15.6195C96.2976 38.9045 72.1041 33.7196 59.1122 27.137C46.8678 20.9332 33.2506 14.4474 20.4925 19.5115C5.01202 25.6565 -1.08778 38.9792 22.4651 68.7422C55.8415 110.919 -14.3518 127.237 2.7205 168.894Z",
    fill: "#ECEFF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7010_85482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.736 51.8303L44.9306 66.112C42.2075 66.5706 40.3718 69.1499 40.8303 71.873L58.2674 175.415C58.7259 178.138 61.3052 179.974 64.0283 179.515L148.834 165.233C151.557 164.775 153.393 162.196 152.934 159.473L135.497 55.9305C135.039 53.2075 132.459 51.3717 129.736 51.8303Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7010_85482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.756 66.7147L80.2478 57.5338C77.5022 57.239 75.0374 59.2258 74.7426 61.9714L63.5333 166.371C63.2385 169.117 65.2253 171.582 67.971 171.877L153.48 181.058C156.225 181.352 158.69 179.366 158.985 176.62L170.194 72.2199C170.489 69.4743 168.502 67.0095 165.756 66.7147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.4932,
    y: 72.3491,
    width: 67.8563,
    height: 4.67975,
    rx: 2,
    transform: "rotate(5.81837 86.4932 72.3491)",
    fill: "#546E7A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.1211,
    y: 95.6272,
    width: 67.8563,
    height: 4.67975,
    rx: 2,
    transform: "rotate(5.81837 84.1211 95.6272)",
    fill: "#546E7A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.749,
    y: 118.905,
    width: 67.8563,
    height: 4.67975,
    rx: 2,
    transform: "rotate(5.81837 81.749 118.905)",
    fill: "#546E7A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5439,
    y: 81.6604,
    width: 24.5687,
    height: 4.67975,
    rx: 2,
    transform: "rotate(5.81837 85.5439 81.6604)",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.1719,
    y: 104.938,
    width: 24.5687,
    height: 4.67975,
    rx: 2,
    transform: "rotate(5.81837 83.1719 104.938)",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.7998,
    y: 128.217,
    width: 24.5687,
    height: 4.67975,
    rx: 2,
    transform: "rotate(5.81837 80.7998 128.217)",
    fill: "#78909C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50C81.2091 50 83 48.2091 83 46C83 43.7909 81.2091 42 79 42C76.7909 42 75 43.7909 75 46C75 48.2091 76.7909 50 79 50Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101 50C103.209 50 105 48.2091 105 46C105 43.7909 103.209 42 101 42C98.7909 42 97 43.7909 97 46C97 48.2091 98.7909 50 101 50Z",
    fill: "#546E7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123 50C125.209 50 127 48.2091 127 46C127 43.7909 125.209 42 123 42C120.791 42 119 43.7909 119 46C119 48.2091 120.791 50 123 50Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.212 146.732C107.958 147.026 110.422 145.039 110.717 142.293C111.011 139.548 109.024 137.083 106.278 136.789C103.532 136.494 101.068 138.481 100.774 141.227C100.479 143.973 102.466 146.437 105.212 146.732Z",
    fill: "#DFEAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.352 163.425C106.557 163.34 105.814 163.26 105.142 163.145C104.315 162.999 103.545 162.628 102.915 162.073C102.286 161.518 101.821 160.799 101.573 159.997L98.2674 151.257C97.9981 150.866 97.8944 150.384 97.9788 149.917C98.0632 149.449 98.3289 149.034 98.718 148.762C99.0346 148.559 99.4117 148.472 99.7853 148.515C100.06 148.553 100.323 148.649 100.556 148.798C100.79 148.947 100.988 149.145 101.138 149.378L102.764 152.183L102.79 152.22L103.849 142.341C103.901 141.851 104.146 141.402 104.53 141.093C104.914 140.783 105.405 140.639 105.895 140.692C106.385 140.744 106.834 140.989 107.143 141.373C107.453 141.757 107.597 142.247 107.544 142.738L106.852 149.201C106.856 148.96 106.91 148.724 107.01 148.506C107.111 148.288 107.256 148.093 107.436 147.934C107.616 147.775 107.827 147.655 108.056 147.582C108.284 147.509 108.526 147.485 108.765 147.51C109.003 147.536 109.234 147.611 109.442 147.731C109.651 147.851 109.832 148.012 109.974 148.206C110.116 148.399 110.216 148.621 110.268 148.855C110.32 149.089 110.323 149.332 110.276 149.568L110.131 150.915C110.136 150.675 110.19 150.438 110.29 150.22C110.391 150.002 110.535 149.807 110.715 149.648C110.895 149.489 111.107 149.369 111.335 149.297C111.564 149.224 111.806 149.199 112.045 149.225C112.283 149.25 112.514 149.326 112.722 149.445C112.931 149.565 113.111 149.727 113.254 149.92C113.396 150.114 113.496 150.335 113.548 150.569C113.6 150.804 113.603 151.047 113.556 151.282L113.445 152.32C113.449 152.08 113.503 151.843 113.603 151.625C113.704 151.407 113.849 151.212 114.029 151.053C114.209 150.894 114.42 150.775 114.649 150.702C114.877 150.629 115.119 150.604 115.358 150.63C115.596 150.656 115.827 150.731 116.035 150.85C116.244 150.97 116.425 151.132 116.567 151.326C116.709 151.519 116.809 151.74 116.861 151.975C116.913 152.209 116.916 152.452 116.869 152.687L116.193 158.988C115.952 160.922 114.725 164.096 111.644 163.765C111.419 163.751 109.512 163.658 107.356 163.426L107.352 163.425Z",
    fill: "#263238",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7010_85482",
    x: 34.7598,
    y: 42.76,
    width: 124.245,
    height: 139.825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7010_85482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7010_85482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7010_85482",
    x: 57.5039,
    y: 48.5049,
    width: 118.719,
    height: 135.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7010_85482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7010_85482",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProgram);
export default __webpack_public_path__ + "static/media/no-program.dabaa31478bf3444f1370168a9aab51d.svg";
export { ForwardRef as ReactComponent };